module.exports = "<button class=\"btn btn-primary\" (click)=\"download()\">\n    Télécharger\n</button>"